import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import MyProfileAvatar from '@/components/my-profile-avatar.tsx';
import { EventRulesTable } from '@/features/event-rules/components/event-rules-table/event-rules-table.tsx';
import { useGetUserEventRulesQuery } from '@/features/event-rules/hooks/queries/use-get-event-rules.ts';
import { eventRulesTableColumns } from '@/features/event-rules/components/event-rules-table/event-rules-table-columns.tsx';
import { TableErrorBoundary } from '@/components/ui/table-error-boundary.tsx';

const EMPTY_DATA: never[] = [];

const EventRulesPage = () => {
  const { data: eventRules, isLoading } = useGetUserEventRulesQuery();

  return (
    <div className="w-full gap-2 px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Event Rules</h1>

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <TableErrorBoundary>
            <EventRulesTable
              data={eventRules ?? EMPTY_DATA}
              columns={eventRulesTableColumns}
              isLoading={isLoading}
            />
          </TableErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default EventRulesPage;
